module.exports = __webpack_public_path__ + "media/images/flags/gb-eng-6402fdd4373e2e5872395670210b09ff.svg";